import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-plus-icon',
  templateUrl: './lib-plus-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibPlusIconComponent {}
